<template>
  <div class="form-group">
    <label v-if="label" class="d-block">{{ label }}<span v-if="required" class="text-danger ml-1">*</span></label>
    <div :class="{ 'd-flex flex-wrap': inline }">
      <div
        v-for="option in options"
        :key="option.value"
        class="custom-control custom-radio"
        :class="{ 'mr-4': inline }"
      >
        <input
          :id="`${name}_${option.value}`"
          type="radio"
          class="custom-control-input"
          :name="name"
          :value="option.value"
          :checked="value === option.value"
          :disabled="disabled"
          @change="$emit('input', option.value)"
        />
        <label class="custom-control-label font-weight-normal" :for="`${name}_${option.value}`">{{ option.label }}</label>
      </div>
    </div>
    <div v-if="error" class="text-danger small mt-1">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'FRadioGroup',
  props: {
    name: { type: String, required: true },
    label: String,
    value: { default: null },
    options: { type: Array, default: () => [] },
    disabled: Boolean,
    required: Boolean,
    inline: Boolean,
    error: { type: String, default: null }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormFields/FRadioGroup.vue